import type { CookedEvent } from '@fullstory/client-api';

export enum PlaybackTypes {
  ClearSession = 'playback.clearSession',
  LoadSession = 'playback.loadSession',
  UpdateWithLiveData = 'playback.updateWithLiveData',
  TimeChange = 'playback.timeChange',
  ClearEventTypesFilter = 'playback.events.filter.clearEventTypes',
  ToggleEventTypesFilter = 'playback.events.filter.toggleEventType',
  SetTextFilter = 'playback.events.filter.setText',
  ClearAllFilters = 'playback.events.filter.clearAll',
  AddNote = 'playback.notes.add',
  AddSentNote = 'playback.notes.addSentNote',
  GetNotePreviewRequest = 'playback.notes.getPreview.request',
  GetNotePreviewSuccess = 'playback.notes.getPreview.success',
  GetNotePreviewFailure = 'playback.notes.getPreview.failure',
  DeleteNoteRequest = 'playback.notes.delete.request',
  DeleteNoteSuccess = 'playback.notes.delete.success',
  DeleteNoteFailure = 'playback.notes.delete.failure',
  CreateShareLinkRequest = 'playback.notes.createShareLink.request',
  CreateShareLinkSuccess = 'playback.notes.createShareLink.success',
  CreateShareLinkFailure = 'playback.notes.createShareLink.failure',
  DeleteSessionRequest = 'playback.deleteSession.request',
  DeleteSessionSuccess = 'playback.deleteSession.success',
  DeleteSessionFailure = 'playback.deleteSession.failure',
}

export const FAKE_EVENT_COOKED_CHANGE_TAB = 'change_tab';
export const FAKE_EVENT_COOKED_CLOSE_TAB = 'close_tab';
export const FAKE_EVENT_COOKED_NEW_TAB = 'new_tab';
export const FAKE_EVENT_COOKED_REFERRED_BY = 'refer';

export interface FakeEventChangeTabDetails {
  FromTabId: string;
  FromTabIndex: number;
  ToTabId: string;
  ToTabIndex: number;
}

export interface FakeEventCloseTabDetails {
  TabId: string;
  TabIndex: number;
}

export interface FakeEventNewTabDetails {
  TabId: string;
  TabIndex: number;
}

export type FakeCookedEventDetails = {
  ChangeTabDetails?: FakeEventChangeTabDetails;
  CloseTabDetails?: FakeEventCloseTabDetails;
  NewTabDetails?: FakeEventNewTabDetails;
};

export type FakeCookedEvent = CookedEvent & FakeCookedEventDetails;

export type FakeCookedEventType =
  | typeof FAKE_EVENT_COOKED_CHANGE_TAB
  | typeof FAKE_EVENT_COOKED_CLOSE_TAB
  | typeof FAKE_EVENT_COOKED_NEW_TAB;

export type DatalossTarget =
  | DatalossElementTarget
  | DatalossNetworkTarget
  | DatalossLogTarget
  | DatalossExceptionTarget;

export type DatalossElementTarget = {
  source: 'element' | 'input';
  origin: string;
  selector: string;
  fId?: number;
  fsId?: number;
  pIds?: number[];
};

export type DatalossNetworkTarget = {
  source:
    | 'page url'
    | 'request url'
    | 'request header'
    | 'response header'
    | 'request body'
    | 'response body';
  origin: string;
  url: string;
};

export type DatalossLogTarget = {
  source: 'console log';
};

export type DatalossExceptionTarget = {
  source: 'exception';
  origin: string;
};
